import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest } from '@angular/common/http';
import { StoreService } from '@root/shared/service/store.service';
import { Observable } from 'rxjs';

@Injectable()
export class EmptyParamsInterceptor implements HttpInterceptor {
  // private operatorId;
  private clientInfo = this.getOSInfo();
  constructor(private storeService: StoreService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const params = req.params;

    if (params instanceof HttpParams) {
      let filteredParams = new HttpParams();

      params.keys().forEach((key) => {
        const value = params.get(key);

        // 定义空值的判断条件
        if (this.isValid(value)) {
          filteredParams = filteredParams.append(key, value);
        }
      });

      filteredParams = filteredParams.append('opid', this.cacheOperatorId()).append('opclient', this.clientInfo);
      req = req.clone({ params: filteredParams });
    }

    return next.handle(req);
  }

  private isValid(value) {
    return !['undefined', 'null', '', undefined, null].includes(value);
  }

  private cacheOperatorId() {
    // if (!this.operatorId) {
    //   this.operatorId = this.storeService.get('operator_id', 1);
    // }
    // return this.operatorId;

    return this.storeService.get('operator_id', 1);
  }

  private getOSInfo() {
    let name = 'unknown';
    let browser = 'unknown';

    const userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('win') !== -1) {
      name = 'Win';
    } else if (userAgent.indexOf('mac') !== -1) {
      name = 'Mac';
    } else if (userAgent.indexOf('linux') !== -1) {
      name = 'Linux';
    }

    if (userAgent.indexOf('edg') !== -1) {
      browser = 'Edge';
    } else if (userAgent.indexOf('firefox') !== -1) {
      browser = 'Firefox';
    } else if (userAgent.indexOf('chrome')) {
      browser = 'Chrome';
    } else if (userAgent.indexOf('safari')) {
      browser = 'Safari';
    }

    return `Web-${name}-${browser}`;
  }
}
